
import { FacetFilterType } from "@studyportals/search-api-interface";
import { FilterType } from "@domain/enums/FilterType";

export const FILTER_TO_FACETS_MAPPER: Map<FilterType, FacetFilterType>  = new Map([
	[FilterType.DURATION, FacetFilterType.DURATIONS],
	[FilterType.ATTENDANCE, FacetFilterType.ATTENDANCES],
	[FilterType.DENSITIES, FacetFilterType.DENSITIES],
	[FilterType.DISCIPLINES, FacetFilterType.DISCIPLINES],
	[FilterType.DEGREE_TYPE, FacetFilterType.DEGREE_TYPES],
	[FilterType.SPECIAL_PROGRAMMES, FacetFilterType.SPECIAL_PROGRAMMES],
	[FilterType.COUNTRY, FacetFilterType.COUNTRY_ISO_CODES],
	[FilterType.CONTINENT, FacetFilterType.REGION_IDS],
	[FilterType.AREA, FacetFilterType.AREA_IDS],
	[FilterType.ORGANISATIONS, FacetFilterType.ORGANISATIONS_IDS],
]);
